import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { KeyRound, LogOut, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, get, setToken, logout, fmtDT, formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { InstallPanel } from "@/components/InstallApp";

function ChangeCode() {
  const [f, setF] = useState({ current_code: "", new_code: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const { data: info, refetch } = useQuery({ queryKey: ["auth-info"], queryFn: () => get("/auth/info") });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_code !== f.confirm) return toast.error("La confirmation ne correspond pas au nouveau code");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-code", { current_code: f.current_code, new_code: f.new_code });
      setToken(data.token);
      toast.success(data.message);
      setF({ current_code: "", new_code: "", confirm: "" });
      refetch();
    } catch (ex) { toast.error(formatErr(ex.response?.data?.detail)); }
    setBusy(false);
  };
  const field = (k, label, id) => (
    <label className="block text-[11px] text-slate-500">{label}
      <Input data-testid={id} type="password" autoComplete={k === "current_code" ? "current-password" : "new-password"} className="h-8 text-xs mt-0.5 font-mono" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
    </label>
  );
  return (
    <form onSubmit={submit} className="panel p-4 space-y-3" data-testid="change-code-form">
      <h2 className="font-display font-bold flex items-center gap-1.5"><KeyRound className="h-4 w-4" />Code d'accès</h2>
      <p className="text-xs text-slate-500">Un code unique protège l'application. Après modification, les autres navigateurs connectés devront saisir le nouveau code.
        {info?.updated_at && <span className="block font-mono text-[10px] mt-1" data-testid="code-updated-at">Dernière modification : {fmtDT(info.updated_at)} ({info.origin})</span>}</p>
      {field("current_code", "Code actuel", "current-code-input")}
      {field("new_code", "Nouveau code (4 caractères minimum)", "new-code-input")}
      {field("confirm", "Confirmer le nouveau code", "confirm-code-input")}
      <Button data-testid="change-code-submit" size="sm" disabled={busy || !f.current_code || f.new_code.length < 4}>Modifier le code</Button>
    </form>
  );
}

export default function Settings() {
  return (
    <div className="p-4 lg:p-6 max-w-2xl space-y-4" data-testid="settings-page">
      <h1 className="font-display text-xl font-bold">Paramètres</h1>
      <ChangeCode />
      <div className="panel p-4 space-y-2">
        <h2 className="font-display font-bold flex items-center gap-1.5"><Mail className="h-4 w-4" />Récapitulatif matinal</h2>
        <p className="text-xs text-slate-500">Adresse e-mail, heure d'envoi et activation se règlent sur la page <Link to="/recap" className="underline">Récap du jour</Link>.</p>
      </div>
      <InstallPanel />
      <div className="panel p-4 flex flex-wrap gap-2 items-center justify-between">
        <div className="text-xs text-slate-500">Fermer la session sur ce navigateur.</div>
        <Button data-testid="logout-btn" size="sm" variant="outline" onClick={logout}><LogOut className="h-3.5 w-3.5 mr-1" />Se déconnecter</Button>
      </div>
    </div>
  );
}
